<svg
    width="311"
    height="187"
    viewBox="0 0 311 187"
    xmlns="http://www.w3.org/2000/svg">
    <!-- Roof -->
    <svg:path
        class="outer-roof"
        d="M138 1 L231 60 L96 144 L3 85 L138 1 Z" />
    <svg:path
        d="M220 60 L139 7 L14 84 L95 136 L220 60 Z"
        [attr.fill]="'var(--roof-bg)'" />

    <g
        [x]="-20"
        [y]="-55"
        [hideLowerBox]="true"
        app-roof-box></g>

    <g
        [x]="-70"
        [y]="15"
        [hideLowerBox]="true"
        app-roof-box></g>

    <g
        [x]="-60"
        [y]="65"
        app-square-vent></g>
</svg>
